<template>
    <div class="horizontal-wrapper" style="gap: 20pt; flex-wrap:wrap; overflow-y: scroll; flex: 1 0 auto;">
        <md-card class="md-layout-item" style="padding: 10pt">
            <md-card-header>
                <div class="md-title">Adresse</div>
            </md-card-header>

            <div class="horizontal_wrapper">
              <md-field style="width: auto; flex: 4 0 0;">
                <label for="">Street</label>
                <md-input v-model="location.street"></md-input>
              </md-field>
              <div style="flex: 0 0 24px"></div>
              <md-field style="width: auto; flex: 1 0 0;">
                <label for="">Nr</label>
                <md-input v-model="location.streetnr"></md-input>
              </md-field>
            </div>
            <div class="horizontal_wrapper">
              <md-field style="width: auto; flex: 1 0 0;">
                <label for="">Postalcode</label>
                <md-input v-model="location.postalcode"></md-input>
              </md-field>
              <div style="flex: 0 0 24px"></div>
              <md-field style="width: auto; flex: 2 0 0;">
                <label for="">City</label>
                <md-input v-model="location.city"></md-input>
              </md-field>
              <div style="flex: 0 0 24px"></div>
              <md-field style="width: auto; flex: 1 0 0;">
                <label for="">Country</label>
                <md-input v-model="location.country"></md-input>
              </md-field>
            </div>

        </md-card>

        <md-card class="md-layout-item "  style="padding: 10pt">
            <md-card-header class="horizontal-wrapper">
                <div class="md-title">Daten</div>
                <md-button style="margin-top: 8px;" v-on:click="reset">Zurücksetzen</md-button>
            </md-card-header>

            <div class="vertical-wrapper">
                <ForecastChips title="Regen Risiko" name="rain-risk" v-model="rainRisk"></ForecastChips>
                <ForecastChips title="Regen Menge" name="rain-amount" v-model="rainAmount" ></ForecastChips>
                <ForecastChips title="Temperatur" name="temperatur"  v-model="temperatur"></ForecastChips>
                <ForecastChips title="rel Feuchtigkeit" name="humidity" v-model="humidity"></ForecastChips>

                <md-switch v-model="sunHoursEnabled" class="md-primary">Sonnenstunden [sun-hours]</md-switch>
                <md-switch v-model="uvIndexEnabled" class="md-primary">UV-Index [uv-index]</md-switch>
            </div>

        </md-card>

    </div>
</template>
<script>
import ForecastChips from './forecast-chips.vue';

export default{
    name: 'weather-watcher-settings',
    components: {ForecastChips},
    computed:{
        location(){
            return this.$store.getters['settingsMaschines/location']
        },
        options(){
            return this.$store.getters['settingsMaschines/options']
        },


        rainRisk:{
            get(){
                return this.options.filter(e => e.includes('rain-risk'))
            },
            set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [...v, ...this.options.filter(e => !e.includes('rain-risk'))])
            }
        },
        rainAmount:{
            get(){
                return this.options.filter(e => e.includes('rain-amount'))
            },
            set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [...v, ...this.options.filter(e => !e.includes('rain-amount'))])
            }
        },

        temperatur:{
            get(){
                return this.options.filter(e => e.includes('temperatur'))
            },
            set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [...v, ...this.options.filter(e => !e.includes('temperatur'))])
            }
        },
        humidity:{
            get(){
                return this.options.filter(e => e.includes('humidity'))
            },
            set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [...v, ...this.options.filter(e => !e.includes('humidity'))])
            }
        },
        sunHoursEnabled : {
            get(){
                return this.options.some(e => e == 'sun-hours')
            },set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [ ...(v? ['sun-hours']: []), ...this.options.filter(e => !e.includes('sun-hours'))])
            }
        },
        uvIndexEnabled : {
            get(){
                return this.options.some(e => e == 'uv-index')
            },set(v){
                this.$store.commit('settingsMaschines/SET_OPTIONS', [ ...(v? ['uv-index']: []), ...this.options.filter(e => !e.includes('uv-index'))])
            }
        }
    },
    props: {
       
    },
    methods:{
        reset(){
            this.$store.commit('settingsMaschines/SET_OPTIONS', [
                    'forecast4h-rain-risk',
                    'forecast2h-rain-risk',
                    'now-rain-risk',

                    'forecast4h-rain-amount',
                    'forecast2h-rain-amount',
                    'now-rain-amount',
            ])

           
            this.temperatur = []
            this.humidity = []

            this.sunHoursEnabled = false;
            this.uvIndexEnabled = false;

        }  
    },
    data(){
        
        return {
           


        }
    }
}
</script>